import React from 'react';
import { Section } from '../ui/Section';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <Section className="bg-slate-50" data-id="element-105">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-106">
        <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-12 shadow-xl border border-slate-200 text-center relative overflow-hidden hover:shadow-2xl transition-shadow" data-id="element-107">
          <div className="absolute top-0 left-0 w-full h-1.5 md:h-2 bg-teal-500" data-id="element-108"></div>

          <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full bg-teal-50 mb-4 md:mb-6 hover:scale-110 transition-transform cursor-default" data-id="element-109">
            <ShieldCheck className="h-8 w-8 md:h-10 md:w-10 text-teal-600" data-id="element-110" />
          </div>

          <h2 className="text-xs md:text-sm font-bold text-teal-600 tracking-widest uppercase mb-1 md:mb-2" data-id="element-111">
            7 Días
          </h2>
          <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4 md:mb-6" data-id="element-112">
            GARANTÍA TOTAL
          </h3>

          <p className="text-lg md:text-xl text-slate-700 font-medium mb-3 md:mb-4" data-id="element-113">
            7 días para probarlo o te devolvemos el 100%
          </p>

          <p className="text-sm md:text-base text-slate-600 leading-relaxed" data-id="element-114">
            Descargás el material, empezás a implementar las plantillas en tu
            consultorio. Si no es lo que esperabas: sin preguntas, sin
            formularios, sin drama. Te reintegramos el dinero inmediatamente.
          </p>
        </div>
      </div>
    </Section>;
}